import { useMemo } from "react";
import { randomAffiliate, type Affiliate } from "@/lib/affiliates";

// Re-rolls each time `seed` changes. Pass route/key/page id so it rotates per visit.
export function useRandomAffiliate(seed: unknown, exclude?: string[]): Affiliate {
  return useMemo(() => randomAffiliate(exclude), [seed, exclude?.join(",")]);
}
